<template>
<select :value="value" @input="onInput($event.target.value)" ref="prefSelector">
  <slot name="not-selected">
    <option value="">選んで下さい…</option>
  </slot>
  <option v-for="p in prefs" :value="p" :selected="p === value">{{ p }}</option>
</select>
</template>

<script>
import api from 'api'
import modal from 'util/modal'
export default {
  props: ['value'],
  data () {
    return {
      prefs: []
    }
  },
  created () {
    api.fetchPrefectures(this)
      .then(prefs => {
        this.prefs = prefs
      }).catch(err => {
        if (err.status === 401) {
          api.onAuthRequired(this)
        } else {
          modal.showErrorModal(this, err)
        }
      })
  },
  methods: {
    onInput (value) {
      this.$refs.prefSelector.value = value
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// PrefectureSelector.vue?0658adf4